import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import PrivacyPage from "@/pages/legal/Privacy";

export const Route = createFileRoute("/$lang/aviso-de-privacidad")({
  head: ({ params }) => pageHead(params.lang, "privacy"),
  component: PrivacyPage,
});
